@if (!item.hidden) {
  <!-- normal collapse -->
  @if (!item.url && !item.function) {
    <a [attr.data-e2e]="'nav-collapse-' + item.id" class="nav-link" tabindex="0" [ngClass]="item.classes"
      (focus)="toggleOpen($event)" (mousedown)="toggleOpen($event)" (keydown.enter)="toggleOpen($event)" matRipple>
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  }
  <!-- item.url -->
  @if (item.url && !item.externalUrl && !item.function) {
    <a [attr.data-e2e]="'nav-collapse-' + item.id" class="nav-link" [ngClass]="item.classes"
      (click)="toggleOpen($event)"
      [routerLink]="[item.url]" [routerLinkActive]="['active', 'mat-accent-bg']"
      [routerLinkActiveOptions]="{exact: item.exactMatch || false}"
      [target]="item.openInNewTab ? '_blank' : '_self'" matRipple>
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  }
  <!-- item.externalUrl -->
  @if (item.url && item.externalUrl && !item.function) {
    <a [attr.data-e2e]="'nav-collapse-' + item.id" class="nav-link" [ngClass]="item.classes"
      (click)="toggleOpen($event)"
      [href]="item.url" [target]="item.openInNewTab ? '_blank' : '_self'" matRipple>
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  }
  <!-- item.function -->
  @if (!item.url && item.function) {
    <span [attr.data-e2e]="'nav-collapse-' + item.id" class="nav-link" [ngClass]="item.classes"
      (click)="toggleOpen($event);item.function()" matRipple>
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </span>
  }
  <!-- item.url && item.function -->
  @if (item.url && !item.externalUrl && item.function) {
    <a [attr.data-e2e]="'nav-collapse-' + item.id" class="nav-link" [ngClass]="item.classes"
      (click)="toggleOpen($event);item.function()"
      [routerLink]="[item.url]" [routerLinkActive]="['active', 'mat-accent-bg']"
      [routerLinkActiveOptions]="{exact: item.exactMatch || false}" matRipple>
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  }
  <!-- item.externalUrl && item.function -->
  @if (item.url && item.externalUrl && item.function) {
    <a [attr.data-e2e]="'nav-collapse-' + item.id" class="nav-link" [ngClass]="item.classes"
      (click)="toggleOpen($event);item.function()"
      [href]="item.url" [target]="item.openInNewTab ? '_blank' : '_self'" matRipple>
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  }
  <ng-template #itemContent>
    @if (item.icon && !item.hasOwnProperty('displayIcon') || (item.hasOwnProperty('displayIcon') && item['displayIcon'])) {
      <mat-icon class="nav-link-icon"
      [svgIcon]="item.icon"></mat-icon>
    }
    <span class="nav-link-title" [translate]="item.translate"></span>
    @if (item.badge) {
      <span class="nav-link-badge" [translate]="item.badge.translate"
        [ngStyle]="{'background-color': item.badge.bg,'color': item.badge.fg}">
      </span>
    }
    <mat-icon class="collapsable-arrow"
      svgIcon="expand-arrow">
    </mat-icon>
  </ng-template>
  <div class="children" [@slideInOut]="isOpen">
    @for (item of item.children; track item) {
      @if (exist) {
        @if (item.type=='item') {
          <fuse-nav-vertical-item [item]="item"></fuse-nav-vertical-item>
        }
        @if (item.type=='collapsable') {
          <fuse-nav-vertical-collapsable
          [item]="item"></fuse-nav-vertical-collapsable>
        }
        @if (item.type=='group') {
          <fuse-nav-vertical-group [item]="item"></fuse-nav-vertical-group>
        }
      }
    }
  </div>
}
